import { Question } from "../../interfaces/purchase-order.interface";
import { QuestionType } from "../../enums/question-type.enum";

export class annexesQuestion {
  public static question_annexes: Question[] = [
    {
      type: "radio",
      question: "¿Qué deseas hacer con este documento?",
      control: "question_toDo",
      options: [
        { label: "Aceptarlo", value: { value: "Aceptarlo", incident: false } },
        {
          label: "Rechazarlo",
          value: { value: "Rechazarlo", incident: true, incident_text: "El documento fue rechazado." },
        },
      ],
      page: 1,
    },
    {
      type: "radio-textbox",
      question: "¿Quieres compartir observaciones internas?",
      control: "comment_obsv",
      answer: undefined,
      options: [
        { label: "Sí", value: { value: "other", incident: true, show_alternative_question: true } },
        { label: "No", value: { value: "no", incident: false, show_alternative_question: false } },
      ],
      label: "Instrucciones",
      alternative_question:
        "instrucciones específicas que el especialista debe de seguir para corregir este documento.",
      page: 1,
    },
    {
      type: "radio-textbox",
      question: "¿Quieres compartir instrucciones de incidencia al especialista?",
      control: "comment_instructions_incident",
      answer: undefined,
      options: [
        { label: "Sí", value: { value: "other", incident: true, show_alternative_question: true } },
        { label: "No", value: { value: "no", incident: false, show_alternative_question: false } },
      ],
      label: "Instrucciones",
      alternative_question:
        "instrucciones específicas que el especialista debe de seguir para corregir este documento.",
      page: 1,
    },
  ];
}
